import { config } from './config';
import axios from "axios";

export const creationFoundKeywordNetworkComplianceService = {
    patch,
    get,
    config
};

function get(params){

    let axiosConfig = {}

    let endpoint;

    params['nocache'] = Date.now();
    // Append to request.
    axiosConfig['params'] = params;

    endpoint = '/api/creation/found-keyword-network-compliance/';

    return new Promise((resolve, reject) => {
      axios
        .get(`${config.apiUrl}${endpoint}`, axiosConfig)
        .then(response => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
}

function patch(id, params){

    let endpoint;

    endpoint = '/api/creation/found-keyword-network-compliance/' + id + '/';

    return new Promise((resolve, reject) => {
      axios
        .patch(`${config.apiUrl}${endpoint}`, params)
        .then(response => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
}

